var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"v-app"}},[_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[_c('router-view')],1)],1),_c('client-out-of-date-warning'),_c('global-error-warning')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }